import { render, staticRenderFns } from "./ReportingDashboard.vue?vue&type=template&id=3422c38c&"
import script from "./ReportingDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports